type OverrideReasonProps = {
    applicationReason?: string | null;
    paymentReason?: string | null;
    status?: string;
};

const InfoRow = ({ label, value }: { label: string; value: string }) => {
    return (
        <div className="flex items-center space-x-2 md:space-x-6 mb-2">
            <p className="text-grey-600 text-sm md:text-base font-semibold shrink-0 basis-1/3">
                {label}
            </p>
            <p className="text-grey-600 text-sm md:text-base shrink-0">:</p>
            <p className="text-grey-600 text-sm md:text-base grow inline-block min-w-[100px] text-wrap break-words">
                {value}
            </p>
        </div>
    );
};

export const OverrideReason = ({
                                   applicationReason,
                                   paymentReason,
                                   status,
                               }: OverrideReasonProps) => {
    if (status === "Draft") return null;

    return (
        <>
            {applicationReason && (
                <InfoRow
                    label="Override Reason For Application Approval"
                    value={applicationReason}
                />
            )}

            {paymentReason && (
                <InfoRow
                    label="Override Reason For Payment Approval"
                    value={paymentReason}
                />
            )}
        </>
    );
};